export interface OlProps {
	title?: string;
	desc?: string;
	descItems?: string[];
	customNumber?: string;
}

export enum OlSize {
	Small,
	Medium,
	Large,
}
